import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "grid gap-5 border-t border-gray-100 pt-5 sm:grid-cols-2"
}

import { computed, inject, onMounted, ref } from 'vue'

import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StoreMinimums',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const enabled = ref(false)
const minimumItems = ref(0)
const minimumPrice = ref('0.00')

const load = () => {
  const attrs = store.value.attributes
  enabled.value = Boolean(attrs.minimum_items_count || attrs.minimum_price_cents)
  minimumItems.value = attrs.minimum_items_count || 0
  minimumPrice.value = (attrs.minimum_price_cents / 100).toFixed(2)
}

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=none`)
  loading.value = false
  load()
})

const dirty = () => bus.emit('dirty/store', { from: 'basics' })

const toggle = () => {
  if (enabled.value) return
  minimumItems.value = 0
  minimumPrice.value = '0.00'

  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      minimum_price_cents: null,
      minimum_items_count: null
    }
  })
}

bus.on('save/store', () => {
  minimumPrice.value = Number(minimumPrice.value).toFixed(2)
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      minimum_price_cents: Math.round(minimumPrice.value * 100),
      minimum_items_count: minimumItems.value
    }
  })
})

bus.on('discard/store', load)

return (_ctx, _cache) => {
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_InputField = _resolveComponent("InputField")
  const _component_SettingsSection = _resolveComponent("SettingsSection")
  const _component_NeueLoading = _resolveComponent("NeueLoading")

  return (_openBlock(), _createBlock(_component_NeueLoading, { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SettingsSection, {
          title: "Cart minimums",
          description: "Hold customers to a minimum order before they can check out. A cart below the minimum cannot be completed."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Require a minimum"),
                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means a cart of any size can check out.")
              ], -1)),
              _createVNode(_component_NeueToggle, {
                modelValue: enabled.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((enabled).value = $event)),
                onChange: toggle
              }, null, 8, ["modelValue"])
            ]),
            (enabled.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_InputField, {
                    modelValue: minimumItems.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((minimumItems).value = $event)),
                    name: "Minimum quantity",
                    prefix: "#",
                    onInput: dirty
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_InputField, {
                    modelValue: minimumPrice.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((minimumPrice).value = $event)),
                    name: "Minimum subtotal",
                    prefix: "$",
                    onInput: dirty
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}